export const MAP_STYLE = {
  street: "mapbox://styles/mapbox/standard",
  satellite: "mapbox://styles/mapbox/standard-satellite",
};

export const MARKER_LAYER_ID = "marker-circle-layer";
export const CIRCLE_LAYER_FILL_ID = "circle-fill";
export const CIRCLE_LAYER_OUTLINE_ID = "circle-outline";

export const BIN_TO_COLOR = {
  Low: "#2ECC71",
  Medium: "#F1C40F",
  High: "#E74C3C",
};

export const BIN_TO_TEXT_COLOR = {
  Low: "#1b964f",
  Medium: "#f1a90f",
  High: "#E74C3C",
};
